module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper animate fadeIn"
  }, [_c('div', {
    staticClass: "order-detail mb-0"
  }, [(_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "header-title"
  }, [_vm._v("รายการที่คุณบริจาค")]), _vm._v(" "), _c('div', {
    staticClass: "block-primary block shadow radius border _clearfix mb-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h2', {
    staticClass: "header__bar"
  }, [_c('span', {
    staticClass: "col-xs-8 pd-0"
  }, [_vm._v("เลขที่บริจาค #" + _vm._s(_vm.order.order_id))]), _vm._v(" "), _c('span', {
    staticClass: "text-right col-xs-4 pd-0"
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.order.created)))])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {},
    attrs: {
      "id": "",
      "cellspacing": "0",
      "cellpadding": "2",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.order.invoice_product_list), function(item) {
    return _c('tr', {
      key: item.product_sku
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product_detail',
          params: {
            sku: item.product_sku
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.product_name) + "\n                            "), (item.catalog_sku) ? _c('span', [_vm._v("(" + _vm._s(item.catalog_name) + ")")]) : _vm._e()]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("money")(item.product_price)))])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "label--light text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("ช่องทางการชำระเงิน:")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.paymentMethod))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "label text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("ยอดรวมทั้งหมด:")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("money")(_vm.order.total_price)))])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "header__bar"
  }, [_vm._v("\n              ข้อมูลผู้บริจาค\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pd-15"
  }, [_c('div', [_c('div', {
    staticClass: "label--light"
  }, [_vm._v("อีเมล:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:..."
    }
  }, [_vm._v(_vm._s(_vm.order.email))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "label--light"
  }, [_vm._v("เบอร์ติดต่อ:")]), _vm._v(" " + _vm._s(_vm.order.phone_number))]), _vm._v(" "), (_vm.order.note) ? _c('div', [_c('div', {
    staticClass: "label"
  }, [_vm._v("Note:")]), _vm._v(" " + _vm._s(_vm.order.note))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "pd-15 block-third mb-15 text-center"
  }, [_c('div', {
    staticClass: "label text-center mb-15"
  }, [_vm._v("สถานะ")]), _vm._v(" "), _c('order-status', {
    attrs: {
      "order": _vm.order
    }
  })], 1), _vm._v(" "), (_vm.isBankTransfer && !_vm.isBankTransferExpired && !_vm.isPaid) ? _c('div', {
    staticClass: "label pd-15 block-third"
  }, [(_vm.isWaitForApprove) ? _c('div', [_c('router-link', {
    staticClass: "btn btn--purple btn--center mt-30",
    attrs: {
      "tag": "button",
      "to": {
        name: 'upload-slip',
        params: {
          orderId: _vm.order.public_order_id || _vm.order.order_id
        }
      }
    }
  }, [_vm._v("ส่งหลักฐานการโอนเงินเพิ่มเติม")]), _vm._v(" "), _vm._m(1)], 1) : _c('div', [_c('p', {
    staticClass: "text-muted pd-15"
  }, [_vm._v("เตรียมหลักฐานการโอนเงินเป็นรูปภาพหรือรูปถ่าย เช่น รูปถ่ายใบเสร็จการโอนเงินจากตู้ ATM หรือรูปภาพหน้าจอในกรณีที่ทำธุรกรรมออนไลน์")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn--purple btn--center mt-30",
    attrs: {
      "tag": "button",
      "to": {
        name: 'upload-slip',
        params: {
          orderId: _vm.order.public_order_id || _vm.order.order_id
        }
      }
    }
  }, [_vm._v("ส่งหลักฐานการโอนเงิน")])], 1)]) : _vm._e()])])])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("รายการ")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("จำนวนเงิน")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-remark text-secondary text-center"
  }, [_vm._v("กรณีที่ต้องการส่งหลักฐานการโอนเงินใหม่"), _c('br'), _vm._v("สามารถส่งได้อีกครั้งที่นี่")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e6427874", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6427874","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderDetail.vue
// module id = 763
// module chunks = 1